"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { links } from "@/data/links";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

const NotFound = () => {
  const pathname = usePathname();
  const lang = pathname.split("/")[1] as Lang;
  const { t } = getTranslations(lang);

  return (
    <main className="grid min-h-screen-dvh place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-sky-700">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          {t.error.pageNotFound}
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          {t.error.pageNotFoundMessage}
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            href={`/${lang}${links.home}`}
            className="rounded-md bg-sky-700 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-sky-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
          >
            {t.error.goBackHome}
          </Link>
          <Link
            href={`/${lang}${links.contact}`}
            className="text-sm font-semibold text-gray-900"
          >
            {t.error.contactSupport} <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
